import { State } from 'src/types'
import { beltBackStyleDrawerLeftThrow } from './beltBackStyleDrawer'
import { crownBackStyleDrawerLeftThrow } from './crownBackStyle'
import { firstBackStyleDrawerLeftThrow } from './firstBackStyleDrawer'

export const backStyleOfGloveBackDrawerLeftThrow = (
  ctx: CanvasRenderingContext2D,
  state: State,
  needCatchFaceWrap: boolean,
  canvasWidth: number
): void => {
  // 通常ベルトモデル
  beltBackStyleDrawerLeftThrow(ctx, state, needCatchFaceWrap, canvasWidth)
  // 王冠モデル
  crownBackStyleDrawerLeftThrow(ctx, state, needCatchFaceWrap, canvasWidth)
  // ファーストバックモデル
  firstBackStyleDrawerLeftThrow(ctx, state, canvasWidth)
}
